/* eslint "import/no-mutable-exports": "off" */

const commonTypes = [
  { type: 'MONTHS_1_4', title: 'employment_duration.months_1_4', intl: true },
  { type: 'MONTHS_5_12', title: 'employment_duration.months_5_12', intl: true },
  { type: 'YEARS_1_2', title: 'employment_duration.years_1_2', intl: true },
  { type: 'YEARS_3_5', title: 'employment_duration.years_3_5', intl: true },
  { type: 'YEARS_6_10', title: 'employment_duration.years_6_10', intl: true },
  { type: 'YEARS_OVER_10', title: 'employment_duration.years_over_10', intl: true },
];

const fiTypes = [
  { type: 'MORE_THAN_THREE_YEARS', title: 'employment_duration.more_than_three_years', intl: true },
  { type: 'ONE_TO_THREE_YEARS', title: 'employment_duration.one_to_three_years', intl: true },
  { type: 'LESS_THAN_ONE_YEAR', title: 'employment_duration.less_than_one_year', intl: true },
];

const esTypes = [
  { type: 'MONTHS_1_6', title: 'employment_duration.months_1_6', intl: true },
  { type: 'MONTHS_7_12', title: 'employment_duration.months_7_12', intl: true },
  { type: 'YEARS_1_3', title: 'employment_duration.years_1_3', intl: true },
  { type: 'YEARS_4_10', title: 'employment_duration.years_4_10', intl: true },
  { type: 'YEARS_OVER_10', title: 'employment_duration.years_over_10', intl: true },
];

const plTypes = [
  { type: 'MONTHS_LESS_3', title: 'employment_duration.months_less_3', intl: true },
  { type: 'MONTHS_3_12', title: 'employment_duration.months_3_12', intl: true },
  { type: 'YEARS_1_3', title: 'employment_duration.years_1_3', intl: true },
  { type: 'YEARS_OVER_3', title: 'employment_duration.years_over_3', intl: true },
];

const auTypes = [
  { type: 'DURATION_PROBATION', title: 'employment_duration.duration_probation', intl: true },
  { type: 'DURATION_UP_TO_6M', title: 'employment_duration.months_up_to_6', intl: true },
  { type: 'DURATION_UP_TO_1Y', title: 'employment_duration.years_up_to_1', intl: true },
  { type: 'DURATION_UP_TO_2Y', title: 'employment_duration.years_up_to_2', intl: true },
  { type: 'DURATION_2Y_TO_3Y', title: 'employment_duration.years_2_3', intl: true },
  { type: 'DURATION_3Y_TO_5Y', title: 'employment_duration.years_3_5', intl: true },
  { type: 'DURATION_5Y_TO_7Y', title: 'employment_duration.years_5_7', intl: true },
  { type: 'DURATION_8Y_AND_MORE', title: 'employment_duration.years_over_8', intl: true },
];

const ltTypes = [
  { type: 'FROM_0_TO_3_MONTHS', title: 'employment_duration.months_0_3', intl: true },
  { type: 'FROM_4_TO_12_MONTHS', title: 'employment_duration.months_4_12', intl: true },
  { type: 'FROM_13_AND_MORE_MONTHS', title: 'employment_duration.months_over_12', intl: true },
];

const mxTypes = [
  { type: 'LESS_THAN_ONE_YEAR', title: 'employment_duration.less_than_one_year', intl: true },
  { type: 'ONE_TO_THREE_YEARS', title: 'employment_duration.one_to_three_years', intl: true },
  { type: 'MORE_THAN_THREE_YEARS', title: 'employment_duration.more_than_three_years', intl: true },
];

let data = [];

switch (COUNTRY) {
  case 'FI':
    data = data.concat(fiTypes);
    break;
  case 'ES':
    data = data.concat(esTypes);
    break;
  case 'PL':
    data = data.concat(plTypes);
    break;
  case 'AU':
    data = data.concat(auTypes);
    break;
  case 'LT':
    data = data.concat(ltTypes);
    break;
  case 'MX':
    data = data.concat(mxTypes);
    break;
  default:
    data = data.concat(commonTypes);
}

export default data;
